import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 21"
      className="design-iconfont"
    >
      <path
        d="M6.3,9.7225 C6.48333334,9.7225 6.63333334,9.87166666 6.63333334,10.0558333 L6.6325,15.5558333 L8.31583334,15.5558333 L8.31583334,10.0558333 C8.31583334,9.87166668 8.46583334,9.7225 8.64916666,9.7225 L11.35,9.7225 C11.5341667,9.7225 11.6833333,9.87166666 11.6833333,10.0558333 L11.6833333,15.5558333 L13.3666667,15.5558333 L13.3666667,10.0558333 C13.3666667,9.87166668 13.5166667,9.7225 13.7,9.7225 L16.4008333,9.7225 C16.585,9.7225 16.7341667,9.87166666 16.7341667,10.0558333 L16.7341667,15.5558333 L18,15.5558333 C18.1833333,15.5558333 18.3333333,15.705 18.3333333,15.8891667 L18.3333333,16.3891667 C18.3333333,16.849404 17.9602373,17.2225 17.5,17.2225 L2.5,17.2225 C2.0397627,17.2225 1.66666666,16.849404 1.66666666,16.3891667 L1.66666666,15.8891667 C1.66666666,15.705 1.81666666,15.5558333 2,15.5558333 L3.26583334,15.5558333 L3.26583334,10.0558333 C3.26583334,9.87166668 3.415,9.7225 3.59916666,9.7225 L6.29916666,9.7225 L6.3,9.7225 Z M10.6208333,2.03833334 L10.7208333,2.10916666 L18.265,8.04 C18.4411492,8.17826038 18.5181698,8.40805441 18.4609227,8.6245428 C18.4036755,8.84103119 18.2231339,9.00271672 18.0016667,9.03583334 L17.9183333,9.04250258 L2.08166666,9.04250258 C1.85869725,9.04317426 1.6565069,8.91170207 1.56667175,8.70762988 C1.47683661,8.50355768 1.51642243,8.26565258 1.6675,8.10166666 L1.73416666,8.04 L9.27916666,2.10916666 C9.6665468,1.80457088 10.2035338,1.77622064 10.6208333,2.03833334 L10.6208333,2.03833334 Z"
        fill="#00A870"
        transform="translate(0 .861538)"
        fillRule="nonzero"
      />
    </svg>
  )
}

const GovernmentAffairsIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default GovernmentAffairsIcon
